module.exports = __webpack_public_path__ + "../resources/img/ic_scrolltop_hover.5cebfb8e.svg";